import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";
import PageMeta from "@/components/PageMeta";
import { categories, articles } from "@/help/articles";
import { ArrowRight, Question } from "@phosphor-icons/react";

export default function Help() {
  return (
    <PageShell
      eyebrow="Help center"
      title="Find an answer in 30 seconds."
      subtitle="Guides, tutorials, and troubleshooting for sending, receiving, teams, and billing. If something isn't here, write to support@sendme.co.in — we read every message."
    >
      <PageMeta
        title="Help center · Guides for sending, receiving, teams, billing"
        description="12 step-by-step SendMe guides — send your first file, receive safely, create a team workspace, upgrade to Pro, troubleshoot uploads and OTPs."
        keywords="SendMe help, file transfer tutorial, team workspace setup, upload troubleshoot, OTP not received"
      />
      <div className="grid md:grid-cols-2 gap-6" data-testid="help-categories">
        {categories.map((c) => {
          const items = articles.filter((a) => a.category === c.id);
          return (
            <section key={c.id} className="brut-card p-6" data-testid={`help-cat-${c.id}`}>
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 grid place-items-center bg-[#FF3366]/10 text-[#FF3366]">
                  <Question size={18} weight="duotone" />
                </div>
                <div>
                  <h2 className="text-xl tracking-tight">{c.label}</h2>
                  <p className="text-sm text-black/55 mt-1">{c.desc}</p>
                </div>
              </div>
              <ul className="space-y-2">
                {items.map((a) => (
                  <li key={a.slug}>
                    <Link
                      to={`/help/${a.slug}`}
                      className="flex items-start justify-between gap-3 py-2 text-sm hover:text-[#FF3366] group"
                      data-testid={`help-link-${a.slug}`}
                    >
                      <span className="leading-snug">{a.title}</span>
                      <ArrowRight size={14} className="mt-1 opacity-30 group-hover:opacity-100 flex-shrink-0" />
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>

      <div className="mt-14 brut-card p-7 text-center max-w-2xl mx-auto">
        <div className="small-caps mb-2 text-[#FF3366]">Still stuck?</div>
        <h3 className="text-2xl tracking-tight mb-3">We reply within 2 business days.</h3>
        <p className="text-black/65 mb-5">
          Write to <a href="mailto:support@sendme.co.in" className="underline">support@sendme.co.in</a> or use the <Link to="/contact" className="underline">contact form</Link>. A real person reads every message.
        </p>
      </div>
    </PageShell>
  );
}
